import { Box, Button, Skeleton, Typography } from "@mui/material";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import EditIcon from '@mui/icons-material/Edit';
import { useEffect } from 'react';
import axios from 'axios';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import veg from "../Assets/product_management/Foodmark.svg"
import nonVeg from "../Assets/product_management/non-veg.svg"
import { updateAvailable, updateInventoryDetail, updateInventoryDetailsModal, updateInventryHubsupervisors, updateSelectedBatchNo, updateSelectedInventoryId, updateTotalOrdered, updateallInventryDetails, updateinventoryDetailsEdit } from "../Redux/inventory";
import { useState , useMemo} from "react";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import Tooltip from '@mui/material/Tooltip';
import CustomAxios from "../utils/CustomAxios";
import { useDateformate, useGetBatchHistory, useGetInventoryDetails } from "../Components/globalFunctions";
import { useNavigate } from "react-router-dom";
import { updatepageName } from "../Redux/page";
import { ReturnRequestModal } from "../Components/ReturnRequestModal";
export function InventoryBatchTable() {
    const toast = useRef(null);
    const dispatch = useDispatch();
    const user_id = useSelector( state => state.user.id)
    const batchHistory = useSelector(state => state.inventory.batchHistory)
    const dateFormat = useDateformate()
    const selectedInventoryId = useSelector(state => state.inventory.selectedInventoryId)
    const inventoryDetailsLoading = useSelector(state => state.inventory.inventoryDetailsLoading);
    const getBatchHistory = useGetBatchHistory()
    const [matchedProducts, setMatchedProducts] = useState([]);
    const selectedHubValue = useSelector(state => state.user.selected_hub);
    const [returnRequestModal, setReturnRequestModal] = useState(false);
    const [selectedBatchForReturn, setSelectedBatchForReturn] = useState(null);
    const [submittingReturn, setSubmittingReturn] = useState(false);
    
    const user_role = localStorage.getItem('role');
    const assignedHubs = JSON.parse(localStorage.getItem('hub') || '[]');
    
    const resolvedSelectedHub = useMemo(() => {
        const normalizeValue = (value) => {
            if (value === null || value === undefined) return null;
            if (Array.isArray(value)) {
                if (value.length === 0) return null;
                return normalizeValue(value[0]);
            }
            if (typeof value === 'string') {
                if (value.trim() === '' || value === 'null') return null;
                const parsed = Number(value);
                return Number.isNaN(parsed) ? value : parsed;
            }
            return value;
        };

        const direct = normalizeValue(selectedHubValue);
        if (direct !== null && direct !== undefined) return direct;

        const stored = localStorage.getItem('selected_hub');
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                const normalized = normalizeValue(parsed);
                if (normalized !== null && normalized !== undefined) return normalized;
            } catch (error) {
                const normalized = normalizeValue(stored);
                if (normalized !== null && normalized !== undefined) return normalized;
            }
        }
        return null;
    }, [selectedHubValue]);

    const normalizedAssignedHubs = useMemo(() => {
        if (Array.isArray(assignedHubs)) {
            return assignedHubs
                .map((id) => Number(id))
                .filter((id) => !Number.isNaN(id));
        }
        const parsed = Number(assignedHubs);
        return Number.isNaN(parsed) ? [] : [parsed];
    }, [assignedHubs]);

    const hasHubAccess = useMemo(() => {
        if (!resolvedSelectedHub) return false;
        if (normalizedAssignedHubs.length === 0) return true;
        return normalizedAssignedHubs.includes(Number(resolvedSelectedHub));
    }, [resolvedSelectedHub, normalizedAssignedHubs]);

    const canEditBatch = () => {
        if (user_role === 'super_admin') return true; 
        if (user_role === 'admin') return hasHubAccess;
        if (user_role === 'supervisor') return hasHubAccess;
        if (user_role === 'merchant') return hasHubAccess;
        return false;
    };

    const canDeleteBatch = () => {
        if (user_role === 'super_admin') return true;
        if (user_role === 'admin') return hasHubAccess;
        if (user_role === 'supervisor') return hasHubAccess;
        if (user_role === 'merchant') return hasHubAccess;
        return false; 
    };

    useEffect(() => {
        getBatchHistory()
    }, [])

    const handleSearch = () => {
        const matches = batchHistory
            .flatMap((entry) => entry.batch
                .filter((product) => {
                    console.log("Comparing:", product.product, selectedInventoryId.product_id);
                    return product.product.id == Number(selectedInventoryId.product_id); // Ensure comparison is correct
                }).map((product) => ({
                    ...product,
                    purchased_on: entry.purchased_on,
                    batchno: entry.batch_number,
                    batch_id: entry.id,
                    return_status: entry.return_status || 'active',
                    supplier: entry.supplier,
                }))
            );

            let total = 0
            let available = 0
            let units = ""
            console.log(matches,inventoryDetailsLoading,selectedInventoryId)
            matches.map((batch)=>{
                const returnStatus = batch.return_status || 'active';
                const isReturned = returnStatus === 'returned';
                
                // Calculate total ordered (always include all batches)
                if (batch.units=="ml" || batch.units=='gms'){
                    console.log( batch.quantity,batch.available_units)
                    total +=parseFloat( batch.quantity)/1000
                    // For available: only count if not returned
                    // When return is requested, inventory is already reduced in backend
                    // So we should exclude those batches from available calculation
                    if (!isReturned && returnStatus !== 'request_raised') {
                        // Use inventory_details.available_units if available (more accurate), 
                        // otherwise fall back to batch.available_units
                        const availableQty = batch.inventory_details?.available_units ?? batch.available_units ?? 0;
                        available += parseFloat(availableQty)/1000
                    }
                }
                else{
                    total += parseFloat(batch.quantity)
                    // For available: only count if not returned
                    // When return is requested, inventory is already reduced in backend
                    // So we should exclude those batches from available calculation
                    if (!isReturned && returnStatus !== 'request_raised') {
                        // Use inventory_details.available_units if available (more accurate), 
                        // otherwise fall back to batch.available_units
                        const availableQty = batch.inventory_details?.available_units ?? batch.available_units ?? 0;
                        available += parseFloat(availableQty)
                    }
                }
                
                // units = batch.units
            })
            setMatchedProducts(matches);
        dispatch(updateTotalOrdered(parseFloat(total).toFixed(2)+" "+selectedInventoryId.units))
        dispatch(updateAvailable(parseFloat(available).toFixed(2)+" "+selectedInventoryId.units))
    };

    useEffect(() => {
        handleSearch();
    }, [batchHistory]);
      const confirmDelete = (item) => {
        console.log(item)
        confirmDialog({
          message: (
            <Box sx={{ display: "flex", gap: "10px", flexDirection: "column" }}>
              <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                Do you want to delete this Batch detail
              </Typography>
            </Box>
          ),
          header: "Delete Confirmation",
          defaultFocus: 'reject',
          acceptClassName: 'p-button-danger',
          accept: () => accept(item),
        });
      };
    
      const accept = async (batch) => {
        try {
          await CustomAxios.delete(`inventory/details/delete/${batch.batch}/`,{data:{admin_id:user_id,batch_details_id:batch.id,batch_delete:false}})
          .then(() => {
            getBatchHistory()
            dispatch(updateSelectedBatchNo({}))
            toast.current.show({
                  severity: "success",
                  summary: "Success",
                  detail: "Batch details deleted successfully",
                  life: 3000,
                });
          })
                
        } catch (err) {
          console.error("Error deleting delivery details", err);
        }
      };

    const handleRequestReturn = (batch) => {
        setSelectedBatchForReturn(batch);
        setReturnRequestModal(true);
    };

    const handleSubmitReturnRequest = async (requestReason) => {
        setSubmittingReturn(true);
        try {
            await CustomAxios.post(`inventory/batch/${selectedBatchForReturn.batch_id}/return-action/`, { 
                action: 'request',
                request_reason: requestReason
            });
            toast.current.show({
                severity: "success",
                summary: "Success",
                detail: "Return request raised successfully",
                life: 3000,
            });
            setReturnRequestModal(false);
            setSelectedBatchForReturn(null);
            getBatchHistory();
        } catch (err) {
            toast.current.show({
                severity: "error",
                summary: "Error",
                detail: err.response?.data?.error || "Failed to request return",
                life: 3000,
            });
        } finally {
            setSubmittingReturn(false);
        }
    };

    const handleCloseReturnModal = () => {
        setReturnRequestModal(false);
        setSelectedBatchForReturn(null);
    };

    const handleCancelReturn = async (batch) => {
        confirmDialog({
            message: (
                <Box sx={{ display: "flex", gap: "10px", flexDirection: "column" }}>
                    <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                        Cancel return request for batch {batch.batchno}?
                    </Typography>
                    <Typography sx={{ fontSize: "14px", color: "gray" }}>
                        This will restore inventory counts back to current values.
                    </Typography>
                </Box>
            ),
            header: "Cancel Return Request",
            accept: async () => {
                try {
                    await CustomAxios.post(`inventory/batch/${batch.batch_id}/return-action/`, { action: 'cancel' });
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Return request cancelled successfully",
                        life: 3000,
                    });
                    getBatchHistory();
                } catch (err) {
                    toast.current.show({
                        severity: "error",
                        summary: "Error",
                        detail: err.response?.data?.error || "Failed to cancel return",
                        life: 3000,
                    });
                }
            },
        });
    };

    const handleCompleteReturn = async (batch) => {
        confirmDialog({
            message: (
                <Box sx={{ display: "flex", gap: "10px", flexDirection: "column" }}>
                    <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                        Mark batch {batch.batchno} as returned?
                    </Typography>
                    <Typography sx={{ fontSize: "14px", color: "gray" }}>
                        This will mark the return as completed. The inventory counts have already been reduced.
                    </Typography>
                </Box>
            ),
            header: "Mark as Returned",
            accept: async () => {
                try {
                    await CustomAxios.post(`inventory/batch/${batch.batch_id}/return-action/`, { action: 'complete' });
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Batch marked as returned successfully",
                        life: 3000,
                    });
                    getBatchHistory();
                } catch (err) {
                    toast.current.show({
                        severity: "error",
                        summary: "Error",
                        detail: err.response?.data?.error || "Failed to mark as returned",
                        life: 3000,
                    });
                }
            },
        });
    };

    const handleOpen = (row) => {
        const filtered = batchHistory.filter((batch)=>{
            console.log(batch.batch_number,row)
                return batch.batch_number === row.batchno
        })
        console.log(filtered[0])

        dispatch(updateinventoryDetailsEdit(true))
        dispatch(updateInventoryDetail(filtered[0]));
        dispatch(updateInventoryDetailsModal(true))
        
    };
    return (<Box>
        <Toast ref={toast} />
        {/* <ConfirmDialog/> */}
        
        {/* Return Request Modal */}
        <ReturnRequestModal
            open={returnRequestModal}
            onClose={handleCloseReturnModal}
            batchNumber={selectedBatchForReturn?.batchno}
            onSubmit={handleSubmitReturnRequest}
            loading={submittingReturn}
        />

        <TableContainer sx={{ height: "100%" }}>
            <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
                <TableHead style={{ backgroundColor: "background.upload" }}>
                    <TableRow >
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">S no</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Batch</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Total Quantity</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Available Quantity</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Purchased on</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Expired</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Bogo Status</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Return Status</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {matchedProducts?.length > 0 ?
                        matchedProducts?.map((item, ind) => {
                            console.log(item)
                            return (<> {
                                <TableRow key={item.id}>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }} >{ind + 1}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }} >{item.batchno}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }} >{item.quantity}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }} >{item.available_units} {item.units}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }} >{dateFormat(item.purchased_on)}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }} >{dateFormat(item.expired_on)}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }} >{item.bogo_enabled?"Active":"Inactive"}</TableCell>
                                    <TableCell sx={{ textAlign: "left", backgroundColor: "white" }}>
                                        {!item.supplier ? <Typography sx={{ fontSize: "12px", color: "gray" }}>No Supplier connected</Typography> : 
                                        (() => {
                                            const status = item.return_status || 'active';
                                            // Only show status badge if it's not active
                                            if (status === 'active' || !status) {
                                                return (
                                                    <Typography sx={{ fontSize: "12px", color: "gray" }}>
                                                        --
                                                    </Typography>
                                                );
                                            }
                                            const statusConfig = {
                                                'request_raised': { label: 'Request Raised', color: '#FF9800', bgColor: '#FFF3E0' },
                                                'cancelled': { label: 'Cancelled', color: '#9E9E9E', bgColor: '#F5F5F5' },
                                                'returned': { label: 'Returned', color: '#F44336', bgColor: '#FFEBEE' },
                                            };
                                            const config = statusConfig[status] || statusConfig['request_raised'];
                                            return (
                                                <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                    <Box sx={{ 
                                                        width: "8px", 
                                                        height: "8px", 
                                                        borderRadius: "50%", 
                                                        backgroundColor: config.color 
                                                    }} />
                                                    <Typography sx={{ fontSize: "12px", color: config.color, fontWeight: 500 }}>
                                                        {config.label}
                                                    </Typography>
                                                </Box>
                                            );
                                        })()}
                                    </TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white", display: "flex", gap: "8px", flexWrap: "wrap" }}>
                                        {(() => {
                                              const allowEdit = canEditBatch();
                                              const allowDelete = canDeleteBatch();
                                              const message = (user_role === 'admin' || user_role === 'supervisor' || user_role === 'merchant')
                                                  ? "You do not have access to manage batches for this hub"
                                                  : "No access";
  
                                                if (!allowEdit && !allowDelete) {
                                                    return (
                                                        <Typography sx={{ fontSize: "12px", fontWeight: 400, color: "gray" }}>
                                                            {message}
                                                        </Typography>
                                                    );
                                                }
                                                return (
                                                    <>
                                                          {allowEdit && (
                                                        <Tooltip title="Update" arrow>
                                                            <Button sx={{ width: "38px", height: "22px", backgroundColor: "button.backgroundEdit", border: "1px solid", borderColor: "borders.green" }} onClick={() => handleOpen(item)}>
                                                                <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.green" }}>Edit</Typography>
                                                            </Button>
                                                        </Tooltip>
                                                    )}
                                                    {allowDelete && (
                                                        <Tooltip title="Delete" arrow>
                                                            <Button sx={{ width: "38px", height: "22px", backgroundColor: "button.backgroundDelete", border: "1px solid", borderColor: "borders.red" }} onClick={() => confirmDelete(item)}>
                                                                <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.red" }}>Delete</Typography>
                                                            </Button>
                                                        </Tooltip>
                                                    )}
                                                    {!item.supplier ? <></> : (() => {
                                                        const returnStatus = item.return_status || 'active';
                                                        if (returnStatus === 'active' || returnStatus === 'cancelled') {
                                                            return (
                                                                <Tooltip title="Request Return" arrow>
                                                                    <Button 
                                                                        sx={{ 
                                                                            width: "auto", 
                                                                            height: "22px", 
                                                                            backgroundColor: "#FF9800", 
                                                                            border: "1px solid", 
                                                                            borderColor: "#FF9800",
                                                                            padding: "0 8px"
                                                                        }} 
                                                                        onClick={() => handleRequestReturn(item)}
                                                                    >
                                                                        <Typography sx={{ fontSize: "12px", fontWeight: 400, color: "white" }}>
                                                                            Request Return
                                                                        </Typography>
                                                                    </Button>
                                                                </Tooltip>
                                                            );
                                                        } else if (returnStatus === 'request_raised') {
                                                            return (
                                                                <>
                                                                    <Tooltip title="Mark as Returned" arrow>
                                                                        <Button 
                                                                            sx={{ 
                                                                                width: "auto", 
                                                                                height: "22px", 
                                                                                backgroundColor: "#F44336", 
                                                                                border: "1px solid", 
                                                                                borderColor: "#F44336",
                                                                                padding: "0 8px"
                                                                            }} 
                                                                            onClick={() => handleCompleteReturn(item)}
                                                                        >
                                                                            <Typography sx={{ fontSize: "12px", fontWeight: 400, color: "white" }}>
                                                                                Mark as Returned
                                                                            </Typography>
                                                                        </Button>
                                                                    </Tooltip>
                                                                    <Tooltip title="Cancel Return Request" arrow>
                                                                        <Button 
                                                                            sx={{ 
                                                                                width: "auto", 
                                                                                height: "22px", 
                                                                                backgroundColor: "#4CAF50", 
                                                                                border: "1px solid", 
                                                                                borderColor: "#4CAF50",
                                                                                padding: "0 8px"
                                                                            }} 
                                                                            onClick={() => handleCancelReturn(item)}
                                                                        >
                                                                            <Typography sx={{ fontSize: "12px", fontWeight: 400, color: "white" }}>
                                                                                Cancel Return
                                                                            </Typography>
                                                                        </Button>
                                                                    </Tooltip>
                                                                </>
                                                            );
                                                        }
                                                        return null;
                                                    })()}
                                                    </>
                                                );
                                        })()}
                                    </TableCell>
                                </TableRow>}</>)
                        })
                        : <TableRow  >
                                <TableCell  colSpan={9} sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white", height: "200px", fontWeight: "700" }}>No Inventory Details Available</TableCell>
                        </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    </Box>)
}